import Big from '@/helpers/bigNumber'

export const SET_KEY = (state, value) => {
  state.key = value
}

export const SET_QUANTITY = (state, value) => {
  if (value && !isNaN(value)) {
    value = (new Big(parseFloat(value).toString())).toNumber()
  }
  state.quantity = value
}

export const SET_ORDERSENDER = (state, value) => {
  state.orderSender = value
}

export const SET_ORDERRECEIVER = (state, value) => {
  state.orderReceiver = value
}

export const SET_OBSERVATION = (state, value) => {
  state.observation = value
}

export const NEW_LINE_STATUS = (state, value) => {
  state.newLine = value
}

export const SET_ITEMSTARTDATE = (state, value) => {
  state.itemStartDate = value
}

export const SET_ITEMENDDATE = (state, value) => {
  state.itemEndDate = value
}
